/**
 * The label for whoever submitted a record, for a column headed "Submitted by".
 *
 * A sales rep shows as a plain name - that is the case these columns were asked for. Anyone else
 * carries their role, so a clinic login or an admin is never silently read as a rep on the one
 * screen used to work out who did what.
 *
 * Shared by the IVR list, which has read this way since 8/25/26, and the orders list, which was
 * still headed SALES REP and reading order.salesRep - a field the server only sets when the
 * submitter's role is sales_rep, so every clinic and admin order read "Unassigned".
 */
export function submitterLabel(user, t = (s) => s) {
  if (!user) return '\u2014';
  const name = `${user.firstName || ''} ${user.lastName || ''}`.trim() || user.email || '\u2014';
  if (!user.role || user.role === 'sales_rep') return name;
  // The role word is the only part of this label that is not data, so it is the only part the
  // optional translator sees (English when no translator is passed).
  const role = user.role === 'master_distributor' ? 'Master distributor' : user.role;
  const label = t(role === 'clinic' ? 'clinic' : role);
  return `${name} (${label})`;
}

export default submitterLabel;
